import { Component, OnDestroy, OnInit } from '@angular/core';
import { NotificationService } from '../../features/notifications/services/notification.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { KeycloakAuthService } from '../../public/services/keycloak-auth.service';
import { StorageService } from '../../public/services/storage.service';
import { SessionService } from '../../public/services/session.service';
import { EventMessageBusService } from '../../core/services/event-message-bus.service';
import { CommunicationService } from '../../features/communications/services/communication.service';
import { FeatureFlagService } from '../../core/services/feature-flag.service';
import {
  AML_DIRECTOR_ROLE, AML_MANAGER_ROLE,
  PARTICIPANT_SUPPORT_VIEWER_ROLE,
  PAYMENT_OFFICER_ROLE,
  PR_MIGRATION_OFFICER_ROLE
} from '../../public/services/auth-roles';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    standalone: false
})
export class MainComponent implements OnInit, OnDestroy {
  isCollapsed = false;
  isShowNotifications = false;

  showNotificationsSub!: Subscription;
  showNotificationContentSub!: Subscription;

  isShowContent: boolean = true;
  isShowNotificationView: boolean = false;
  isCommunicationModalVisible: boolean = false;

  constructor(
    private notificationService: NotificationService,
    private router: Router,
    private keycloakAuth: KeycloakAuthService,
    private storage: StorageService,
    private sessionService: SessionService,
    private messageBus: EventMessageBusService,
    private communicationService: CommunicationService,
    private featureFlags: FeatureFlagService
  ) {}

  ngOnInit(): void {
    if (this.keycloakAuth.isLoggedIn() && !this.storage.getUser()) {
      this.keycloakAuth.loadUserProfile().then((profile) => {
        if (profile) this.storage.saveUser(profile);
      });
    } else if (this.keycloakAuth.isLoggedIn() && this.storage.getUser()) {
      this.storage.setPrimaryEmailFromUser(this.storage.getUser());
    }
    if (this.keycloakAuth.isLoggedIn()) {
      this.sessionService.getSession().subscribe({
        next: (session) => {
          if (session.is_first_login) {
            const user = this.storage.getUser();
            const name = user?.firstName ? `, ${user.firstName}` : '';
            this.messageBus.postMessage({
              type: 'info',
              text: `Welcome to the AFSA Back Office portal${name}. This is your first time signing in.`,
              alertOptions: { timeout: 8000, closable: true }
            });
          }
        },
        error: () => { /* ignore session errors to not block main UI */ }
      });
    }
    this.showNotificationContentSub = this.notificationService.showNotificationContent$.subscribe(resp => {
      this.isShowContent = false;
      this.isShowNotificationView = true
    })

    this.showNotificationsSub = this.notificationService.showNotificationModal$.subscribe(resp => {
      this.isShowNotificationView = false;
      this.isShowContent = true;
      this.toggleNotificationBar();
    })
    this.notificationService.connect();
    this.notificationService.updateCount$.subscribe(resp => {
      console.warn('notificationCount', resp);
    })
    this.communicationService.startUnreadPolling();

    this.communicationService.displayModal$.subscribe(resp => {
      this.toggleCommunication();
    })
  }

  ngOnDestroy(): void {

  }

  hideAll(): void {
    this.isShowNotificationView = false;
    this.isShowContent = true;
  }

  toggleNotificationBar(): void {
    this.isShowNotifications = !this.isShowNotifications;
  }

  toggleCommunication(): void {
    this.isCommunicationModalVisible = !this.isCommunicationModalVisible;
  };

  handleCloseCommunicationModal = () => {
    this.isCommunicationModalVisible = false;
  };

  public get showEntity(): boolean {
    return this.featureFlags.isEnabled('INT_ENTITIES')
      && !this.keycloakAuth.hasRole(PARTICIPANT_SUPPORT_VIEWER_ROLE);
  }

  public get showPayments(): boolean {
    return this.keycloakAuth.hasRole(PAYMENT_OFFICER_ROLE);
  }

  public get showPrMigration(): boolean {
    return this.keycloakAuth.hasRole(PR_MIGRATION_OFFICER_ROLE);
  }

  public get showAmlReporting(): boolean {
    return this.keycloakAuth.hasAnyRole(AML_MANAGER_ROLE, AML_DIRECTOR_ROLE);
    // return true;
  }

  goToApplications(): void {
    this.hideAll();
    this.router.navigate(['/applications']);
  }

  goToEntities(): void {
    this.hideAll();
    this.router.navigate(['/entities']);
  }

  goToPayments(): void {
    this.hideAll();
    this.router.navigate(['/payments']);
  }

  goToPrMigration(): void {
    this.hideAll();
    this.router.navigate(['/pr-migration']);
  }

  goToAmlReporting(): void {
    this.hideAll();
    this.router.navigate(['/aml-reporting']);
  }

  isActive(path: string): boolean {
    return this.router.url.startsWith(path);
  }

}
